﻿import { Component, OnInit } from '@angular/core';
import { SurveysService } from '../surveys.service';
import { SharedService } from '../../shared/shared.service';
import { SurveyList } from '../../core/models/administration/surveys/survey-list';
import { LanguageService } from '../../core/language/language.service';
import { SurveySearch } from '../../core/models/administration/surveys/survey-search';
import { DropdownItem } from '../../core/models/dropdown-item';
import { SecurityService } from '../../core/services/security.service';
import { CONFIG } from '../../core/config';

@Component({
    selector: 'public-survey-list',
    templateUrl: './public-survey-list.component.html'
})
export class PublicSurveyListComponent implements OnInit {
    public offset: number = 0;
    public limit: number = 10;
    public size: number = 0;
    private languageID: number;
    public surveys: SurveyList[];
    public statuses: DropdownItem[] = [];
    public pageNum: number = 1;
    public pageSize: number = this.limit;
    public pathname: string;
    public filteringIsOn = true;
    public searchModel: SurveySearch;
    //sort
    public isDesc: boolean = true;
    public column: string = "";

    public surveyFormId: number = CONFIG.surveyFormEnum.javneAnkete;
    public surveyTypes: DropdownItem[] = [];
    public surveyCategories: DropdownItem[] = [];
    public surveyParticipantTypes: DropdownItem[] = [];
    public surveyStatuses: DropdownItem[] = [];

    constructor(private _surveysService: SurveysService,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _languageService: LanguageService) {
        this.surveys = [];
        this.languageID = this._languageService.selectedLanguageId;
        this.searchModel = new SurveySearch();
    }

    ngOnInit() {
        this.initSearchModel();
        this.pathname = location.pathname;
        this.search();

        this.initCodeLists();
    }

    initQuery() {
        //TODO init search params
        this.searchModel.languageID = this.languageID;
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this.searchModel.column = "";
        this.searchModel.isDesc = this.isDesc;
    }

    initCodeLists() {
        this._sharedService.getAllSurveyTypesForDropdown(0, true, this.languageID).subscribe(result => {
            this.surveyTypes = result;
        });

        this._sharedService.getAllSurveyCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.surveyCategories = result;
        });

        this._sharedService.getAllSurveyParticipantTypesForDropdown(0, true, this.languageID).subscribe(result => {
            this.surveyParticipantTypes = result;
        });

        this._sharedService.getAllSurveyStatusesForDropdown(0, true, this.languageID).subscribe(result => {
            this.surveyStatuses = result;
        });
    }
    initSearchModel() {
        this.searchModel.codeFilter = '';
        this.searchModel.titleFilter = '';
        this.searchModel.dateValidFromFrom = null;
        this.searchModel.dateValidFromTo = null;
        this.searchModel.dateValidToFrom = null;
        this.searchModel.dateValidToTo = null;
        this.searchModel.typeIdFilter = 0;
        this.searchModel.categoryIdFilter = 0;
        this.searchModel.participantTypeIdFilter = 0;
        this.searchModel.statusIdFilter = 0;
        this.searchModel.languageID = this.languageID;
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this.searchModel.column = "";
        this.searchModel.isDesc = this.isDesc;
    }
    search() {
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this.searchModel.participantTypeIdFilter = CONFIG.surveyParticipantTypeEnum.javna;
        this._surveysService.searchSurveys(this.searchModel).subscribe(result => {
            this.surveys = result.results;
            this.size = result.rowCount;
        });
    }

    searchClick() {
        this.pageNum = 1;
        this.offset = 0;
        this.search();
    }

    onLimitChange(newLimit: number) {
        this.offset = 0;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = newLimit;
        this.search();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.search();
    }

    clearSearch() {
        this.offset = 0;
        this.pageNum = 1;
        this.pageSize = this.limit;
        this.initSearchModel();
        this.search();
    }

    sort(column: string) {
        this.column = column;
        this.isDesc = !this.isDesc;

        this.searchModel.column = column;
        this.searchModel.isDesc = !this.searchModel.isDesc;

        this._surveysService.searchSurveys(this.searchModel).subscribe(result => {
            this.surveys = result.results;
            this.size = result.rowCount;
        });
    }
    onDateValidFromFromChanged(date: Date) {
        this.searchModel.dateValidFromFrom = date;
    }
    onDateValidFromToChanged(date: Date) {
        this.searchModel.dateValidFromTo = date;
    }

    onDateValidToFromChanged(date: Date) {
        this.searchModel.dateValidToFrom = date;
    }
    onDateValidToToChanged(date: Date) {
        this.searchModel.dateValidToTo = date;
    }
    downloadPDF() {
        const pdfUrl = "../../../assets/documents/instructions/ankete.pdf"; 
        const pdfName = 'korisnicke_upute_ankete.pdf'; 

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        link.click();
    }
}
